import React from 'react';

function VMBootOrderPanel({
  bootOrder,
  bootDevices,
  bootLoading,
  bootSaving,
  bootMsg,
  bootNeedsReboot,
  onClose,
  onSave,
  onRebootAfterBoot,
  onMoveItem,
  onToggleDevice,
  onDismissReboot,
}) {
  return (
    <div className="boot-panel">
      <div className="boot-panel-header">
        <span className="boot-panel-title">🥾 Boot Order</span>
        <div className="boot-header-actions">
          <button
            className="boot-save-btn"
            onClick={onSave}
            disabled={bootSaving || bootLoading}
          >
            {bootSaving ? '⏳ Salvando...' : '💾 Salvar'}
          </button>
          <button className="logs-close-btn" onClick={onClose}>✕</button>
        </div>
      </div>

      {bootLoading ? (
        <div className="boot-empty">Carregando...</div>
      ) : (
        <div className="boot-body">
          {/* Dispositivos na ordem de boot */}
          <div className="boot-section-label">Ordem de boot</div>
          {bootOrder.length === 0 ? (
            <div className="boot-empty">Nenhum dispositivo na ordem de boot.</div>
          ) : (
            <div className="boot-order-list">
              {bootOrder.map((id, idx) => {
                const dev = bootDevices.find(d => d.id === id);
                return (
                  <div key={id} className="boot-order-item">
                    <span className="boot-order-num">{idx + 1}</span>
                    <span className="boot-device-desc">{dev ? dev.description : id}</span>
                    <div className="boot-order-arrows">
                      <button className="boot-arrow-btn" onClick={() => onMoveItem(idx, -1)} disabled={idx === 0} title="Subir">▲</button>
                      <button className="boot-arrow-btn" onClick={() => onMoveItem(idx, 1)} disabled={idx === bootOrder.length - 1} title="Descer">▼</button>
                      <button className="boot-remove-btn" onClick={() => onToggleDevice(id)} title="Remover da ordem">✕</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Dispositivos fora da ordem */}
          {bootDevices.filter(d => !bootOrder.includes(d.id)).length > 0 && (
            <>
              <div className="boot-section-label" style={{ marginTop: '0.75rem' }}>Dispositivos disponíveis</div>
              <div className="boot-available-list">
                {bootDevices.filter(d => !bootOrder.includes(d.id)).map(dev => (
                  <div key={dev.id} className="boot-available-item">
                    <span className="boot-device-desc muted">{dev.description}</span>
                    <button className="boot-add-btn" onClick={() => onToggleDevice(dev.id)} title="Adicionar à ordem">+ Adicionar</button>
                  </div>
                ))}
              </div>
            </>
          )}

          {bootNeedsReboot && (
            <div className="boot-reboot-notice">
              <span className="boot-reboot-icon">⚠️</span>
              <span className="boot-reboot-text">
                Boot order salva. É necessário reiniciar a VM para aplicar as alterações.
              </span>
              <button className="boot-reboot-btn" onClick={onRebootAfterBoot}>
                ↻ Reiniciar agora
              </button>
              <button className="boot-reboot-dismiss" onClick={onDismissReboot}>
                Depois
              </button>
            </div>
          )}
          {bootMsg && (
            <div className={`boot-msg ${bootMsg.type}`}>{bootMsg.text}</div>
          )}
        </div>
      )}
    </div>
  );
}

export default VMBootOrderPanel;
